module.exports = "https://coursera_assets.s3.amazonaws.com/images/90a1428b8777ff3a441f603df70beb48.jpg";